import React from 'react';
import {useSelector} from "react-redux";
import ContentViewComponent from "../../../Component/ContentViewComponent";
import TableComponent from "../../../Component/TableComponent";
import ApiHandler from "../../../Handler/ApiHandler";
import {hasRight} from "../../../Common/UserCommon";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip} from "@mui/material";
import {Edit} from "@mui/icons-material";
import ButtonComponent from "../../../Component/ButtonComponent";
import {initFormHandler} from "../../../Handler/FormHandler";
import {LinearProgressMainLayoutActivate, LinearProgressMainLayoutDeactivate} from "../../../Action/LinearProgressMainLayoutAction";
import {SnackbarOpen} from "../../../Action/SnackbarAction";
import TextFieldComponent from "../../../Component/TextFieldComponent";
import {dispatch} from "../../../App";
import {TableReload} from "../../../Action/TableAction";

function SettingLifeCycleList() {
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [openDialog, setOpenDialog] = React.useState(false);
    const [lifeCycle, setLifeCycle] = React.useState(null);

    // Global
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: {filter: true, sort: true}
        },
        {
            name: "label",
            label: "Libellé",
            options: {filter: true, sort: true}
        },
        {
            name: "action",
            label: "Action",
            options: {filter: false, sort: false}
        }
    ];
    const getAction = (row) => {
        if ((hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE') || hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE_EDIT'))) {
            return (
                <>
                    <Tooltip title={'Modifier'} placement="left">
                        <IconButton
                            disabled={!(hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE') || hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE_EDIT'))}
                            onClick={() => {
                                handlerForm.reset();
                                setLifeCycle(row.id);
                                handlerForm.setValue('label', row.label);
                                setOpenDialog(true);
                            }}
                        ><Edit style={{color: '#17a2b8'}}/></IconButton>
                    </Tooltip>
                </>
            );
        }
        else {
            return (
                <>
                    <IconButton style={{cursor: 'no-drop'}}>
                        <Edit/>
                    </IconButton>
                </>
            );
        }
    };

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Liste des cycles de vie',
            context: 'Paramétrage',
            description: '',
            links: []
        });
    }, []);

    // Form
    const [form, setForm] = React.useState({
        label: {
            name: 'label',
            label: 'Libellé',
            textHelper: 'Saisissez le libellé du cycle de vie.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        }
    });
    const [isLoadingForm, setIsLoadingForm] = React.useState(false);
    const handlerForm = initFormHandler(form, setForm);
    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            setIsLoadingForm(true);
            dispatch(LinearProgressMainLayoutActivate());

            if (lifeCycle) {
                ApiHandler.post({
                    route: 'api_setting_life_cycle_edit',
                    data: handlerForm.getData(),
                    params: {id: lifeCycle}
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_life_cycle_list'));
                        setLifeCycle(null);
                        dispatch(
                            SnackbarOpen({
                                text: 'Cycle de vie modifié avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_life_cycle');
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
            else {
                ApiHandler.post({
                    route: 'api_setting_life_cycle_add',
                    data: handlerForm.getData()
                }, (response) => {
                    if (response.status === 200) {
                        setOpenDialog(false);
                        dispatch(TableReload('api_setting_life_cycle_list'));
                        dispatch(
                            SnackbarOpen({
                                text: 'Cycle de vie créé avec succès.',
                                variant: 'success',
                            })
                        );

                        ApiHandler.clearCache('api_select_life_cycle');
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }

                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
        }
    };

    React.useEffect(handlerForm.start, []);

    return (
        <ContentViewComponent loading={false} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'api_setting_life_cycle_list'}
                title={'Cycles de vie'}
                columns={columns}
                actionFirst={
                    (hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE') || hasRight(authenticationReducer, 'ROLE_SETTING_LIFE_CYCLE_ADD')) ?
                        {
                            label: 'Ajouter un cycle de vie', onClick: () => {
                                setLifeCycle(null);
                                handlerForm.reset();
                                setOpenDialog(true);
                            }
                        } : false
                }
                promiseData={(resolve) => {
                    ApiHandler.get({route: 'api_setting_life_cycle_list'},
                        (response) => {
                            let data = response.data;
                            for (let index in data) {
                                data[index].action = getAction(data[index]);
                            }
                            resolve(data);
                        });
                }}
            />

            <Dialog open={openDialog} maxWidth={'xl'} onClose={() => setOpenDialog(false)}>
                <DialogTitle style={{fontSize: 15}}>{lifeCycle ? 'Modifier un cycle de vie' : 'Ajouter un cycle de vie'}</DialogTitle>
                <DialogContent style={{minWidth: '30vw'}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextFieldComponent id={'label'} handler={handlerForm}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonComponent color={'#5E6E82'} label={'Annuler'} onClick={() => setOpenDialog(false)} disabled={isLoadingForm}/>
                    <ButtonComponent label={'Enregistrer'} onClick={save} loading={isLoadingForm}/>
                </DialogActions>
            </Dialog>
        </ContentViewComponent>
    );
}

export default SettingLifeCycleList;
